"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duration = duration;
exports.getTokenId = getTokenId;

var _ethers = require("ethers");

var _moment = _interopRequireDefault(require("moment"));

function getTokenId(name) {
  return _ethers.ethers.utils.keccak256(_ethers.ethers.utils.toUtf8Bytes(name));
} //1-year 2-month 3-week 4-day


function duration(startTsSec, periodType, num) {
  if (num <= 0) {
    throw Error("num must greater than 0");
  }

  var mnt0 = new _moment["default"](startTsSec * 1000);
  var mnt = new _moment["default"](startTsSec * 1000);
  var mntAfter = null;

  if (periodType == 1) {
    mntAfter = mnt.add(num, 'y');
  } else if (periodType == 2) {
    mntAfter = mnt.add(num, 'M'); // M=month
  } else if (periodType == 3) {
    mntAfter = mnt.add(num * 7, 'd');
  } else if (periodType == 4) {
    mntAfter = mnt.add(num, 'd');
  } else {
    throw Error(periodType + " not supported");
  }

  var duration = mntAfter.diff(mnt0, 'seconds');
  return duration;
}